import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-material-transfer',
  templateUrl: './material-transfer.component.html',
  styleUrls: ['./material-transfer.component.css']
})
export class MaterialTransferComponent implements OnInit {

  data: any;
  cid: any
  form: any | FormGroup
  modelSubtitle = false
  quantityArr: any = []

  checked = false

  name = ""
  version = ""
  isActive = false
  i: any;
  deleteId: any = "";
  products: any = [];
  // vendor: any = [];
  branch: any = [];
  materials: any = [];
  make: any = ''
  modal: any = ''
  slNo: any = ''
  expiryDate: any = ''
  invoiceDate: any = '';
  transferdata: any = [];
  transfer: any = [];
  uomData: any = [];
  prod: any = [];

  singleissue: any = [];
  productSerialNoList: any = []
  id: any;
  InfoObj: any = []
  viewProd: any = []


  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage: number = 10;
  tableSize: number = 10;
  first: number = 0;
  isLoading: any = false

  actionControls: any = {
    isAdd: false,
    isView: false,
    isDelete: false,
    isModify: false
  }

  constructor(private fb: FormBuilder, private toastr: ToastrService, private generic_service: GenericService) { }

  ngOnInit(): void {

    let href: any = window.location.href;
    let messages = href.split('/')
    let action: any = this.generic_service.checkActionControls(messages[messages.length - 1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    this.getAllTransfer(this.pageNumber, this.recordsPerPage)
    this.getAllUomMaster()
    this.form = this.fb.group({
      branchName: ['', [Validators.required]],
      branchIdTo: [''],
      branchId: [''],
      branchIdFrom: [''],
      dcNo: ['', [Validators.required]],
      productName: [''],
      quantity: [''],
      issueNo: [''],
      issueDate: [''],
      transferDate: ['', [Validators.required]],
      branchNameFrom: ['', [Validators.required]],
      productList: this.fb.array([]),
      infoObj: this.fb.array([]),
    })

    this.generic_service.getAllProducts().subscribe(
      (res: any) => {
        this.products = res.response
      }
    )

    this.generic_service.getBranch().subscribe(
      (res: any) => {
        this.branch = res.response
      }
    )
  }

  productNameSelect(index: any) {
    for (let i = 0; i < this.products.length; i++) {
      if (this.products[i].name == this.prod[index].productName) {
        console.log(this.products[i])
        this.prod[index].uomList = this.products[i].supportedUOM
      }
    }

    console.log(this.prod)
  }

  uomChange(index: any) {
    for (var i = 0; this.uomData.length > i; i++) {
      if (this.uomData[i].uomName == this.prod[index].uomName) {
        this.prod[index].uomId = this.uomData[i].uomMasterId
      }
    }
  }

  addP() {
    this.prod.push(
      {
        "productName": "",
        "infoObj": [
          {
            "make": "",
            "modal": "",
            "slNo": null,
            "expiryDate": 0,
          }
        ],
        "quantity": 1,
        "uomId": 0,
        "uomName": "",
        "uomList": [],
        "productList": []

      }
    )
  }

  addi(i: any) {
    this.prod[i].infoObj.push(
      {
        "make": "",
        "modal": "",
        "slNo": null,
        "expiryDate": 0,
      }
    )
    this.prod[i].quantity = this.prod[i].infoObj.length
    console.log(this.prod)

  }

  showp() {
    console.log(this.prod)
  }

  removeProd(i: any) {
    console.log(i)
    this.prod.splice(i, 1)
    console.log(this.prod)
  }

  removeinfoObj(i: any, j: any) {
    console.log(i)
    console.log(j)
    this.prod[i].infoObj.splice(j, 1)
    this.prod[i].quantity = this.prod[i].infoObj.length

    console.log(this.prod)
  }

  get infoArr() {
    return this.form.get('infoObj') as FormArray;
  }


  productListObject() {
    return this.fb.group({
      "productName": [''],
      "infoObj": this.fb.array([this.addInfoObject()]),
    })
  }

  InfoObject() {
    return this.fb.group({
      "make": [''],
      "modal": [''],
      "slNo": [''],
      "expiryDate": [0],
    })
  }

  addInfoObject() {
    this.infoArr.push(this.InfoObject())
  }

  getProductVersion(product: any, index: any) {
    for (var i = 0; i < this.products.length; i++) {
      if (this.products[i].name == product) {
        if (this.products[i].version != 1) {
          this.prod[index].quantity = 0
        }
        return this.products[i].version
      }
    }
  }

  clear() {
    this.prod = []
    this.form.reset()
    console.log(this.prod)
  }



  addTransfer() {

    let isValid: any = true;
    for (let list of this.prod) {
      if (list.productName == "" || list.uomName == "") {
        isValid = false
      }
    }

    if (!this.form.valid || !isValid) {
      this.toastr.error('All fields are mandatory')
      return
    }

    for (let i = 0; i < this.branch.length; i++) {
      if (this.branch[i].name == this.form.get('branchName').value) {
        this.form.patchValue({
          branchIdTo: this.branch[i].branchMasterId
        })
      }
    }


    for (let i = 0; i < this.branch.length; i++) {
      if (this.branch[i].name == this.form.get('branchNameFrom').value) {
        this.form.patchValue({
          branchIdFrom: this.branch[i].branchMasterId
        })
      }
    }

    for (let i = 0; i < this.prod.length; i++) {
      for (let j = 0; j < this.prod[i].infoObj.length; j++) {
        this.prod[i].infoObj[j].expiryDate = new Date(this.prod[i].infoObj[j].expiryDate).getTime()
      }
    }

    let body1 = {
      "version": 1,
      "isActive": true,
      "description": "",
      "branchIdFrom": Number(this.form.get('branchIdFrom').value),
      "branchNameFrom": String(this.form.get('branchNameFrom').value),
      "tranId": String(this.form.get('dcNo').value),
      "tranDate": new Date(this.form.get('transferDate').value).getTime(),
      "branchIdTo": Number(this.form.get('branchIdTo').value),
      "branchNameTo": String(this.form.get('branchName').value),
      "vendorName": '',
      "status": [
        {
          "userId": Number(sessionStorage.getItem("userId")),
          "purchaseTransferStatus": "ENTER",
          "updatedDate": new Date().getTime()
        }
      ],
      "latestStatus": "ENTER",
      "productList": this.prod,
      "cid": Number(this.cid)


    }

    console.log(body1)
    this.generic_service.addTransfer(body1).subscribe(
      (response: any) => {
        console.log(response)
        this.getAllTransfer(this.pageNumber, this.recordsPerPage)
        this.toastr.success(response.message);
        this.cancelModel()
      },
      (err: any) => {
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }

  cancelModel() {
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page;
    this.getAllTransfer(this.pageNumber, this.recordsPerPage)
  }

  getAllTransfer(pageNumber: any, recordsPerPage: any) {
    this.isLoading = true

    this.generic_service.getAllTransfer(pageNumber, recordsPerPage).subscribe(
      (response: any) => {
        this.materials = response.response.materialTransferList;
        this.totalRecords = response.response.totalRecords;
        console.log(response)
        this.isLoading = false

      }
    )
  }


  getTransferById(id: any) {
    this.generic_service.getTransferById(id).subscribe(
      (res: any) => {
        this.transferdata = [];
        this.viewProd = res.response.productList
        this.transferdata.push(res.response);
        console.log(this.transferdata)
      }
    )
  }

  getAllProduct() {
    this.generic_service.getAllProducts().subscribe(
      (res: any) => {
        this.products = res.response
      }
    )
  }

  getAllBranch() {
    this.generic_service.getBranch().subscribe(
      (res: any) => {
        this.branch = res.response
      }
    )
  }

  getAllUomMaster() {
    this.generic_service.getAllUomMaster().subscribe(
      (res: any) => {
        console.log(res)
        this.uomData = res.response
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  getUomId(name: any) {
    for (var i = 0; this.uomData.length > i; i++) {
      if (this.uomData[i].uomName == name) {
        return this.uomData[i].id
      }
    }
  }


  open() {
    this.modelSubtitle = true;
  }
  close() {
    this.modelSubtitle = false;
    this.name = ""
    this.version = ""
    this.isActive = false

  }


  getViewById(id: any) {
    this.id = id
    this.generic_service.getMaterialIssueById(id).subscribe(
      (response: any) => {
        console.log(response)
        this.productSerialNoList = []
        this.singleissue = []
        this.singleissue.push(response.response)
        this.form.patchValue({
          branchId: response.response.branchId,
          branchName: response.response.branchName,
          vendorName: response.response.vendorName,
          productName: response.response.productList[0].productName,
          quantity: response.response.productList[0].quantity,
          issueNo: String(response.response.issueNo),
          issueDate: formatDate(response.response.issueDate, 'yyyy-MM-dd', 'en-US')

        })
        for (var i = 0; i < response.response.productList.length; i++) {
          let body = {
            "productName": response.response.productList[i].productName,
            "requestQty": response.response.productList[i].quantity,
            "approveQty": 0,
            "infoObj": []
          }

          let body1 = {
            "productName": response.response.productList[i].productName,
            "requestQty": response.response.productList[i].quantity,
            "approveQty": 0,
            "infoObj": response.response.productList[i].infoObj
          }

          if (response.response.latestStatus == "REQUESTED") {
            this.productSerialNoList.push(body)
          } else {
            this.productSerialNoList.push(body1)
          }
        }
        console.log(this.form.value)
      },
      (error) => {
        console.log(error)
      }
    )
  }

  addInfoObj(index: any, Qty: any) {
    console.log(Qty)
    let obj = {
      "make": "",
      "modal": "",
      "slNo": 0,
      "expiryDate": 0,
      "url": "",
      "lat": "",
      "lon": "",
    }
    if (this.productSerialNoList[index].requestQty >= this.productSerialNoList[index].approveQty) {
      for (let i = 0; this.productSerialNoList[index].approveQty > i; i++) {
        this.productSerialNoList[index].infoObj.push(obj)
      }
    } else {
      this.productSerialNoList[index].infoObj = []
    }
    console.log(this.productSerialNoList)
  }

  approveTransfer() {
    let res: any = [];
    res = this.transferdata[0];
    for (let i = 0; i < res.productList.length; i++) {
      res.productList[i].approveQty = res.productList[i].quantity
      delete res.productList[i].quantity
      delete res.productList[i].approvedQty
      delete res.productList[i].uomId
      delete res.productList[i].uomName
    }

    let body = {
      "id": Number(this.transferdata[0].materialTransferId),
      "transferStatusDTO": {
        "userId": Number(sessionStorage.getItem("userId")),
        "purchaseTransferStatus": "APPROVED",
        "updatedDate": new Date().getTime()
      },
      "productSerialNoList": res.productList
    }

    console.log(body)
    this.generic_service.updateTransferStatus(body).subscribe(
      (response: any) => {
        console.log(response);
        this.toastr.success(response.message);
        this.cancelModel()
      },
      (err: any) => {
        console.log(err);
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }

  rejectTransfer() {

    let res: any = [];
    res = this.transferdata[0];
    for (let i = 0; i < res.productList.length; i++) {
      res.productList[i].approveQty = res.productList[i].quantity
      delete res.productList[i].quantity
      delete res.productList[i].approvedQty
      delete res.productList[i].uomId
    }
    let body = {
      "id": Number(this.transferdata[0].materialTransferId),
      "issueStatusDTO": {
        "userId": String(sessionStorage.getItem("userId")),
        "issueStatus": "REJECTED",
        "updatedDate": new Date().getTime()
      },
      "productSerialNoList": res.productList
    }
    console.log(body)

    this.generic_service.updatePurchaseStatus(body).subscribe(
      (response: any) => {
        console.log(response)
        this.toastr.success(response.message);
        this.cancelModel()
      },
      (err: any) => {
        console.log(err)
        this.toastr.error(err.error.errors[0].description);

      },
    )
  }



  selectProductName(index: any, productName: any, supportedUOM: any) {
    this.prod[index].productName = productName
    this.prod[index].uomList = supportedUOM
    this.prod[index].productList = []
  }

  getAllByWildSearchWithoutPagination(index: any) {
    this.prod[index].uomList = []
    if (this.prod[index].productName == "") {
      return
    }

    this.generic_service.getAllByWildSearchWithoutPagination(this.prod[index].productName).subscribe(
      (res: any) => {
        console.log(res)
        this.prod[index].productList = res.response
      },
      (err: any) => {
        this.prod[index].productList = []
      }
    )
  }


  searchKey: any = ""

  getMaterialTransferByWildSearch(pageNumber: any, recordsPerPage: any) {
    console.log(this.searchKey)
    if (this.searchKey != "") {
      this.isLoading = true

      this.generic_service.getMaterialTransferByWildSearch(this.searchKey, pageNumber, recordsPerPage).subscribe(
        (response: any) => {
          console.log(response);
          this.materials = response.response.materialTransferList;
          this.totalRecords = response.response.totalRecords;
          this.isLoading = false

        },
        (err: any) => {
          console.log(err)
        }
      )
    } else {
      this.getAllTransfer(this.pageNumber, this.recordsPerPage)
    }
  }

  refreshSearch() {
    this.searchKey = ""
    this.getAllTransfer(this.pageNumber, this.recordsPerPage)
  }

  refreshAll() {
    this.pageNumber = 0
    this.searchKey = ""
    this.getAllTransfer(this.pageNumber, this.recordsPerPage)
  }


}